require 'angular'

angular.module('workflow.app')
  .controller('ProjectExportController', require './ProjectExportController')

angular.module('workflow.app')
  .controller('WorkflowStepController', require './WorkflowStepController')
  .directive('iterationDifference', require './WorkflowStepDirective')
  .directive 'wkfworkflowstep', () ->
    return {
      restrict: 'A',
      template: require('./workflow-step.html')
    }

angular.module('workflow.app')
  .controller('StarredDocumentController', require './StarredDocumentController')
  .directive 'wkfstarreddocument', () ->
    return {
      restrict: 'A',
      template: require('./starred-doc.html')
    }

require('./Partials')
